import { useMemo, useState } from 'react';
import type { HomeDashboard, HomeStatus } from '../../../api/homeV3Api';

export function useDashboardFilters(requests: HomeDashboard['recentRequests']) {
    const [status, setStatus] = useState<HomeStatus | null>(null);
    const [showAll, setShowAll] = useState(false);

    const filteredRequests = useMemo(() => {
        const matching = status
            ? requests.filter((request) => request.normalizedStatus === status)
            : requests;
        return showAll ? matching : matching.slice(0, 6);
    }, [requests, showAll, status]);

    return {
        status,
        setStatus,
        showAll,
        setShowAll,
        filteredRequests,
        matchingCount: status
            ? requests.filter((request) => request.normalizedStatus === status).length
            : requests.length,
    };
}
